import React from 'react';
import { CircularProgress, Stack } from '@mui/material';

export const QuoteListingLoading = () => {
  return (
    <Stack alignItems="center" justifyContent="center" width="100%" height="50rem">
      <CircularProgress />
    </Stack>
  );
};
